import { render, staticRenderFns } from "./RiskList.vue?vue&type=template&id=f12fa4e0&scoped=true"
import script from "./RiskList.vue?vue&type=script&lang=js"
export * from "./RiskList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12fa4e0",
  null
  
)

export default component.exports